<template>
  <header class="header" :class="{'msg-fixed': betSlipState && headerMessageState && mobileBigAndBelow && !isOpenedFromWebView}"  ref="headerpart">
    <resize-observer @notify="headerResize" />
    <!-- <header-messages v-if="headerMessageState && mobileBigAndBelow"></header-messages> -->
    <!-- <header class="header" :style="tabletAndAbove ? {top: scrollValue + 'px'} : {}">     -->
    <!-- <header-messages v-if="headerMessageState && mobileBigAndBelow && !isOpenedFromWebView"></header-messages> -->
    <v-layout align-center class="top-container" :class="{'geo_search': mobileGeolocationInProgress.display}" >
      <v-icon v-if="mobileBigAndBelow"  @click="toggleHamburgerMenu()">menu</v-icon>
      <v-navigation-drawer class="dialog-menu hamburger" v-if="mobileBigAndBelow" v-model="dialogHamburgerMenu" app fixed disable-resize-watcher disable-route-watcher>
        <div class="header">
          <logo mode="hamburgermenu"></logo>
          <v-btn flat @click="toggleHamburgerMenu()" class="close"><v-icon>close</v-icon></v-btn>
        </div>
        <hamburger-menu></hamburger-menu>
      </v-navigation-drawer>
      <v-flex class="logo" v-if="!mobileBigAndBelow">
        <router-link to="/"><img :src="'/static/images/logo/logo-'+brandKey+'.png'" :alt="brandKey"></router-link>
      </v-flex>
      <div class="logo" v-if="mobileBigAndBelow" @click="toTop()">
        <router-link to="/"></router-link>
      </div>
      <v-flex v-if="!mobileBigAndBelow" sm12 align-content-end class="menu">
        <site-navigation  :navigation-section="'HEADER_MENU_RWC'" class="other-links navigation"></site-navigation>
      </v-flex>
      <!-- <v-flex class="account-widget">
        <account-info-widget-component></account-info-widget-component>
      </v-flex> -->
    </v-layout>
    <!-- <div v-if="!mobileBigAndBelow" class="white_menu">
      <main-navigation class="navigation"></main-navigation>
    </div> -->
    <mobile-geolocation-dialog v-if="isOpenedFromWebView && mobileGeolocationInProgress.display"></mobile-geolocation-dialog>
  </header>
</template>

<script>
  import Screen from '@/components/mixins/Screen'
  import Branding from '@/components/mixins/Branding'
  import store from '@/store'

  import MainNavigation from '@/components/common/MainNavigation'
  import SiteNavigation from '@/components/common/SiteNavigation'
  import AccountInfoWidgetComponent from '@/components/account/AccountInfoWidgetComponent'
  import HeaderInfo from '@/components/common/HeaderInfo'
  import HeaderMessages from '@/components/layout/parts/HeaderMessages'
  import mobileGeolocationDialog from '@/components/layout/parts/mobileGeolocationDialog'
  import HamburgerMenu from '@/components/layout/parts/hamburgerMenu'
  import Logo from '@/components/common/Logo'

  export default {
    name: 'HeaderPart',

    mixins: [
      Screen,
      Branding
    ],

    components: {
      MainNavigation,
      AccountInfoWidgetComponent,
      HeaderInfo,
      HeaderMessages,
      SiteNavigation,
      mobileGeolocationDialog,
      HamburgerMenu,
      Logo
    },

    data () {
      return {
      }
    },

    computed: {
      isOpenedFromWebView () {
        return store.getters['getIsOpenedFromWebView']
      },
      headerMessageState () {
        return store.getters['overlayState/getHeaderMessageState']
      },
      isLoggedIn () {
        return store.getters['isLoggedIn']
      },
      betSlipState () {
        return store.getters['overlayState/getBetslipState']
      },
      dialogHamburgerMenu: {
        get: function () {
          return store.getters['overlayState/getHamburgerMenuState']
        },
        set: function (value) {
          if (value) {
            store.dispatch('overlayState/activateHamburgerMenu')
          } else {
            store.dispatch('overlayState/deactivateHamburgerMenu')
          }
        }
      },
      mobileGeolocationInProgress () {
        var data = store.getters['getMobileGeolocationInProgress']
        return data
      }
    },

    methods: {
      headerResize () {
        store.commit('screenState/setHeaderHeight', this.headerHeight())
      },
      goBack () {
        if (this.$route.name === 'event') {
          this.$router.go(-1)
        } else {
          this.$router.push({name: 'home'})
        }
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }, 350)
      },
      headerHeight () {
        if (this.$refs.headerpart) {
          return this.$refs.headerpart.offsetHeight + parseInt(window.getComputedStyle(this.$refs.headerpart).marginTop) + parseInt(window.getComputedStyle(this.$refs.headerpart).marginBottom)
        }
      },
      toTop () {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      },
      toggleHamburgerMenu () {
        if (this.dialogHamburgerMenu) {
          store.dispatch('overlayState/deactivateHamburgerMenu')
        } else {
          store.dispatch('overlayState/activateHamburgerMenu')
        }
      }
    },
    mounted () {
      this.headerResize()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  @import '~@/css/config'

  .header
    background-color: transparent
  .back-btn-wrapper
    padding-left: 15px
    .logo
      padding: 0px
    .buttons
      margin-top: 0px
    .back-btn-text
      font-size 16px
      font-weight: bold
      line-height: 19px
      min-width: 40px
      text-align: right
  .top-container
     z-index 1
    .geo_search
      top: 40px!important 
    @media mobile-big-and-below
      min-height 55px
      background #06283b

  .scrolled
    .header
      background-color #06283b

  .account-widget
    margin-right 20px
    @media mobile-big-and-below
      margin-right: 0px
  .msg-fixed
    z-index 203
</style>



// WEBPACK FOOTER //
// src/components/layout/parts/HeaderPart.vue